import { render, staticRenderFns } from "./InfoBoxSidebar.vue?vue&type=template&id=69cb3d66&scoped=true&"
import script from "./InfoBoxSidebar.vue?vue&type=script&lang=js&"
export * from "./InfoBoxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBoxSidebar.vue?vue&type=style&index=0&id=69cb3d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb3d66",
  null
  
)

export default component.exports